<template>
  <div class="AtlasLoader">
    <div class="AtlasLoader-spinner"><atlas-spinner /></div>
    <div class="AtlasLoader-text" v-if="!hideText">Loading...</div>
  </div>
</template>

<script>
export default {
  name: 'atlas-loader',
  props: {
    hideText: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.AtlasLoader {
  @include size(50px);
  @include position(absolute, 50% null null 50%);
  text-align: center;
  transform: translateX(-50%) translateY(-50%);

  &-spinner {
    margin-bottom: space(2);
  }

  &-text {
    font-size: 10px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
}
</style>
